import { useState } from "react";
import Http from "../../Http";
const useApiCall = (method, endpoint, data) => {
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const clearErrors = () => {
        setErrors({});
    };
    const call = () => {
        setLoading(true);
        return new Promise((resolve, reject) => {
            let call;
            if (method === "post" || method === "put" || method === "patch") {
                call = Http[method](endpoint, data);
            }
            else {
                call = Http[method](endpoint);
            }
            call.then((response) => {
                clearErrors();
                setLoading(false);
                resolve(response);
            }).catch((err) => {
                const responseErrors = err.fieldErrors;
                setErrors(responseErrors);
                setLoading(false);
                reject(err);
            });
        });
    };
    return [call, errors, clearErrors, loading];
};
export default useApiCall;
